export default __webpack_public_path__ + "static/All about Mattresses for a Good Night Sleep-ad484819a274fdef667df650f59059e9.jpg";